// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"5f49fa33","453":"17fb5174","918":"42348c12"}[chunkId] + ".chunk.js";
};